import { render, staticRenderFns } from "./ReceiptCard.vue?vue&type=template&id=fd2fbd18&scoped=true"
import script from "./ReceiptCard.vue?vue&type=script&lang=js"
export * from "./ReceiptCard.vue?vue&type=script&lang=js"
import style0 from "./ReceiptCard.vue?vue&type=style&index=0&id=fd2fbd18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2fbd18",
  null
  
)

export default component.exports